import React from 'react';
import { Navigation } from '../components/Navigation';
import { Hero } from '../components/Hero';
import { Features } from '../components/Features';
import { Updates } from '../components/Updates';
import { WhyVanguard } from '../components/WhyVanguard';
import { Economy } from '../components/Economy';
import { Download } from '../components/Download';
import { Rankings } from '../components/Rankings';
import { News } from '../components/News';
import { Rewards } from '../components/Rewards';
import { ServerInfo } from '../components/ServerInfo';
import { FAQ } from '../components/FAQ';
import { Footer } from '../components/Footer';
import { BackgroundMusic } from '../components/BackgroundMusic';
import { Registration } from '../components/Registration';
export function LandingPage() {
  return <div className="min-h-screen bg-darkerBlue text-white selection:bg-gold/30 selection:text-gold-light" data-id="element-737">
      <BackgroundMusic data-id="element-738" />
      <Navigation data-id="element-739" />
      <main data-id="element-740">
        <Hero data-id="element-741" />
        <Updates data-id="element-742" />
        <Features data-id="element-743" />
        <WhyVanguard data-id="element-744" />
        <Economy data-id="element-745" />
        <Download data-id="element-746" />
        <Rankings data-id="element-747" />
        <Registration data-id="element-748" />
        <News data-id="element-749" />
        <Rewards data-id="element-750" />
        <ServerInfo data-id="element-751" />
        <FAQ data-id="element-752" />
      </main>
      <Footer data-id="element-753" />
    </div>;
}